type Procedure = {
  name: string;
  slug: string;
};

export const filterProceduresBySlug = (
  slugToRemove: string,
  procedures: Procedure[],
): Procedure[] => {
  return procedures.filter(({ slug }) => slug !== slugToRemove);
};
